var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifesaverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4174 36.5502C33.4863 34.1201 38.8682 24.7984 36.4382 15.7295C34.0082 6.66056 24.6864 1.27866 15.6175 3.70867C6.54859 6.13868 1.16669 15.4604 3.5967 24.5293C6.02671 33.5983 15.3484 38.9802 24.4174 36.5502ZM22.088 27.8568C26.3557 26.7133 28.8884 22.3266 27.7448 18.0589C26.6013 13.7911 22.2146 11.2585 17.9469 12.402C13.6792 13.5455 11.1465 17.9322 12.29 22.2C13.4336 26.4677 17.8203 29.0004 22.088 27.8568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52181 30.4748C9.69007 34.6044 13.7013 37.462 18.9753 37.4907M30.3625 33.6248C34.0781 30.7742 36.2075 27.0699 36.6716 22.3962M31.9528 8.64913C29.0937 5.59556 25.6551 3.53814 21.4381 3.18431M9.18245 6.46821C5.22112 9.31167 3.57736 13.5996 3.09551 18.452M12.2883 18.0593C12.6649 16.6585 13.4175 15.3803 14.4615 14.3712M23.2304 12.8028C24.1387 13.2018 24.9696 13.7675 25.6755 14.4722M26.2053 25.2007C26.9232 24.3231 27.4505 23.2991 27.7461 22.1996M17.7777 27.8108C16.4888 27.4337 15.3103 26.7366 14.3588 25.7867",
    stroke: "#57455D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7541 37.2821L19.4806 28.3058C19.3385 27.3045 19.9663 26.3548 20.9431 26.093L22.7968 25.5963C23.688 25.3575 24.627 25.7594 25.0695 26.5692L29.5106 34.6966C30.1318 35.8336 29.5246 37.2522 28.2731 37.5875L23.2519 38.933C22.0926 39.2436 20.9227 38.4703 20.7541 37.2821Z",
    fill: "#EF86B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26714 20.7408L11.819 19.5185C12.8209 19.3753 13.7719 20.0031 14.0338 20.9807L14.4721 22.6166C14.7062 23.4901 14.325 24.412 13.5424 24.8651L5.6074 29.459C4.42937 30.141 2.92898 29.4725 2.64831 28.1405L1.59312 23.1331C1.3547 22.0017 2.12253 20.9044 3.26714 20.7408Z",
    fill: "#EF86B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1098 19.9976L28.1283 20.849C27.1629 20.9313 26.2773 20.3098 26.0265 19.3739L25.596 17.7673C25.3466 16.8366 25.7963 15.8604 26.6657 15.4451L35.4491 11.2486C36.5372 10.7287 37.8344 11.2828 38.2112 12.4284L39.8397 17.38C40.243 18.6064 39.3961 19.8879 38.1098 19.9976Z",
    fill: "#EF86B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1129 3.03537L20.7606 12.039C20.8294 12.9955 20.2097 13.8662 19.2834 14.1144L17.6322 14.5568C16.7118 14.8034 15.7452 14.3665 15.3223 13.5126L11.4358 5.66484C10.8949 4.5727 11.4482 3.25485 12.6066 2.87621L17.4967 1.27784C18.7328 0.873818 20.0196 1.7383 20.1129 3.03537Z",
    fill: "#EF86B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifesaverIcon);
export default __webpack_public_path__ + "static/media/lifesaver-icon.66228a154816b279f20b2c5d5009c4b1.svg";
export { ForwardRef as ReactComponent };